<mat-card-header>
    <mat-card-title class="sub-heading" tabindex="0">{{'BOOKING_SUMMARY_CARD.TITLE' | translate}}</mat-card-title>
</mat-card-header>
<mat-card-content>
    <p *ngIf="globals.blLanguage == 0" tabindex="0">
        {{store?.selectedLocation?.address?.address1}}<br>
        {{store?.selectedLocation?.address?.address2}}<br>
        <span *ngIf="store.selectedLocation?.address?.address3">
            {{store?.selectedLocation?.address?.address3}}<br>
        </span>
        {{store?.selectedLocation?.address?.address4}}<br>
        {{store?.selectedLocation?.address?.postcode}}<br>
        {{store?.selectedLocation?.address?.country}}<br>
    </p>

    <p *ngIf="globals.blLanguage == 1" tabindex="0">
        <span *ngFor="let addressPart of store?.irishAddress;">
            {{addressPart}}<br></span>
    </p>

    <strong *ngIf="store?.clientDetails" tabindex="0">{{'COMMON.LEAD_BOOKER' | translate}}</strong>
    <p *ngIf="store?.clientDetails" tabindex="0">
        {{store?.clientDetails.forenameOne}} {{store?.clientDetails.surname}}<br>
        {{store?.clientDetails.email}}<br>
        {{store?.clientDetails.telephonePrefix}}{{store?.clientDetails.telephone}}<br>
    </p>

    <div *ngIf="applicantArray" tabindex="0">
        <strong>{{'COMMON.APPLICATION' | translate}}</strong>
        <table class="application-table">
            <tbody *ngFor='let application of applicantArray.value; index as i'>
                <u>{{'COMMON.APPLICANT' | translate}} {{i + 1}}</u>
                <tr *ngFor="let values of application | keyvalue;">
                    <td *ngIf="values.key == '11'">{{store?.selectedService.name | translateSplit}}</td>
                    <td class='currencyRight' *ngIf="values.key == '11' && values.value.length > 0">
                        {{(store?.selectedService.price / 100) | currency:'EUR':true }}</td>
                </tr>
                <tr>
                    <td>{{passportFeeArray[i].name | translateSplit}}</td>
                    <td class='currencyRight'>
                        {{(passportFeeArray[i].price / 100) | currency:'EUR':true}}</td>
                </tr>
                <tr *ngFor="let values of application | keyvalue;">
                    <td *ngIf="values.key == '11'">{{values?.value | translateSplit}}</td>
                </tr>
                <tr>
                    <td>{{store?.basketItems[i].start | date: 'EEE d MMMM, HH:mm'}}</td>
                </tr>
                <tr>
                    <td>{{store?.basketItems[i].counter | translateSplit}}</td>
                </tr>
                <hr />
            </tbody>
            <tr>
                <td class="bold">{{'COMMON.TOTAL' | translate}}</td>
                <td class="table-end bold">{{(store?.total / 100) | currency:'EUR':true}}</td>
            </tr>
        </table>
    </div>
</mat-card-content>